"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processProjectsMutations = processProjectsMutations;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
/* This code is AI generated from Model: GPT-5.3-Codex */
/* Prompt: I need to store Project data only the url of the project how
   should I store it please generate the code. Follow other sections */
function toProjectUrlNode(project) {
  const value = (project.url || '').trim();
  if (!value) return null;
  try {
    return (0, _rdflib.sym)(new URL(value).href);
  } catch {
    return null;
  }
}
function normalizeProjectUrlKey(value) {
  const text = (value || '').trim();
  if (!text) return '';
  try {
    const parsed = new URL(text);
    parsed.hash = '';
    return parsed.href;
  } catch {
    return text;
  }
}
function isPatchFailure(message) {
  const text = (message || '').toLowerCase();
  return text.includes(' on patch ') || text.includes('web error: 500') || text.includes('web error: 501') || text.includes('web error: 405') || text.includes('web error: 400');
}
function isMissingGetRecordError(message) {
  return (message || '').toLowerCase().includes('no record of our http get request for document');
}
function statementKey(statement) {
  return `${statement.subject?.toNT?.() || statement.subject?.value} ${statement.predicate?.toNT?.() || statement.predicate?.value} ${statement.object?.toNT?.() || statement.object?.value} ${statement.why?.toNT?.() || statement.why?.value}`;
}
function sanitizePatchStatements(store, deletions, insertions) {
  const safeDeletions = Array.from(new Map((deletions || []).filter(statement => {
    if (!statement || !statement.subject || !statement.predicate || !statement.object) return false;
    return store.holds(statement.subject, statement.predicate, statement.object, statement.why);
  }).map(statement => [statementKey(statement), statement])).values());
  const safeInsertions = Array.from(new Map((insertions || []).filter(statement => Boolean(statement && statement.subject && statement.predicate && statement.object)).map(statement => [statementKey(statement), statement])).values());
  return {
    safeDeletions,
    safeInsertions
  };
}
async function runPutFallback(store, doc, deletions, insertions) {
  const updater = store.updater;
  const fetcher = store.fetcher;
  if (!updater || typeof updater.serialize !== 'function' || !fetcher || typeof fetcher.webOperation !== 'function') {
    throw new Error('Project updates are not supported by this store updater.');
  }
  const currentStatements = store.statementsMatching(undefined, undefined, undefined, doc).slice();
  const deletionKeys = new Set((deletions || []).map(statement => statementKey(statement)));
  const nextStatements = currentStatements.filter(statement => !deletionKeys.has(statementKey(statement))).concat(insertions || []);
  const contentType = 'text/turtle';
  const body = updater.serialize(doc.value, nextStatements, contentType);
  const response = await fetcher.webOperation('PUT', doc.value, {
    noMeta: true,
    contentType,
    body
  });
  if (!response || response.ok !== true) {
    const status = response?.status || 'unknown';
    throw new Error(`Web error: ${status} on PUT of <${doc.value}>`);
  }
  store.remove(deletions);
  insertions.forEach(statement => {
    store.add(statement.subject, statement.predicate, statement.object, statement.why);
  });
}
async function runUpdateWithDavFallback(store, doc, deletions, insertions) {
  const updater = store.updater;
  if (!updater || typeof updater.update !== 'function') {
    throw new Error('Project updates are not supported by this store updater.');
  }
  const {
    safeDeletions,
    safeInsertions
  } = sanitizePatchStatements(store, deletions, insertions);
  if (safeDeletions.length === 0 && safeInsertions.length === 0) {
    return;
  }
  const tryUpdate = () => new Promise((resolve, reject) => {
    updater.update(safeDeletions, safeInsertions, (_uri, ok, message) => {
      if (ok === true) {
        resolve();
        return;
      }
      reject(new Error(message || 'Failed to save projects'));
    });
  });
  try {
    await tryUpdate();
    return;
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    if (!isPatchFailure(message) || typeof updater.updateDav !== 'function') {
      throw error;
    }
    if (store.fetcher && typeof store.fetcher.load === 'function') {
      try {
        await store.fetcher.load(doc);
      } catch {
        // continue to fallback
      }
    }
    try {
      await new Promise((resolve, reject) => {
        updater.updateDav(doc, safeDeletions, safeInsertions, (_uri, ok, body) => {
          if (ok === true) {
            resolve();
            return;
          }
          reject(new Error(body || message || 'Failed to save projects'));
        });
      });
    } catch (davError) {
      const davMessage = davError instanceof Error ? davError.message : String(davError);
      if (!isMissingGetRecordError(davMessage)) {
        throw davError;
      }
      await runPutFallback(store, doc, safeDeletions, safeInsertions);
    }
  }
}
async function mutateProjectEntries(store, subject, projectOps) {
  const doc = subject.doc();
  const existingLinks = store.each(subject, _solidUi.ns.solid('community'), null, doc);
  const existingByUrl = new Map();
  existingLinks.forEach(linkNode => {
    if (!linkNode || linkNode.termType !== 'NamedNode') return;
    const key = normalizeProjectUrlKey(linkNode.value);
    if (key && !existingByUrl.has(key)) {
      existingByUrl.set(key, linkNode);
    }
  });
  const deletions = [];
  const insertions = [];
  const removeLink = link => {
    deletions.push((0, _rdflib.st)(subject, _solidUi.ns.solid('community'), link, doc));
  };
  const addLink = link => {
    insertions.push((0, _rdflib.st)(subject, _solidUi.ns.solid('community'), link, doc));
  };
  projectOps.remove.forEach(project => {
    const entryKey = normalizeProjectUrlKey(project.entryNode || '');
    const urlKey = normalizeProjectUrlKey(project.url);
    const existing = entryKey && existingByUrl.get(entryKey) || urlKey && existingByUrl.get(urlKey);
    if (existing) removeLink(existing);
  });
  projectOps.update.forEach(project => {
    const newLink = toProjectUrlNode(project);
    const urlKey = normalizeProjectUrlKey(project.url);
    const entryKey = normalizeProjectUrlKey(project.entryNode || '');
    const existing = entryKey && existingByUrl.get(entryKey) || urlKey && existingByUrl.get(urlKey);
    if (existing) removeLink(existing);
    if (newLink) addLink(newLink);
  });
  const seenCreateUrlKeys = new Set();
  projectOps.create.forEach(project => {
    const urlKey = normalizeProjectUrlKey(project.url);
    if (urlKey && (existingByUrl.has(urlKey) || seenCreateUrlKeys.has(urlKey))) {
      return;
    }
    const newLink = toProjectUrlNode(project);
    if (!newLink) return;
    addLink(newLink);
    if (urlKey) {
      seenCreateUrlKeys.add(urlKey);
    }
  });
  await runUpdateWithDavFallback(store, doc, deletions, insertions);
}
async function processProjectsMutations(store, subject, mutationPlan) {
  try {
    await mutateProjectEntries(store, subject, mutationPlan);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`Failed to save projects: ${message}`);
  }
}